import { AxiosError } from "axios";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  QUOTE_JOURNEY_TYPE,
  QUOTE_CHANNEL_ONLINE,
  THIRDPARTYRESPONSE_TYPE,
} from "@/config/app-constant";
import { PRODUCT_DOMAIN } from "@/constants";
import axioInstance from "@/libs/axios";
import { RootState } from "@/store/root-reducer";
import { updateQuoteCompleted } from "@/store/slices/quote/quote.slice";
import { QuoteData } from "@/types/quote/quote-data";

interface AddMedicalProps {
  travellerId?: string | undefined | null;
  version?: string;
  hashCode?: string | undefined | null;
  medicalVersion?: number | undefined | null;
  isAlter: null | boolean;
  viewPage?: string;
}

type QuoteResponse = {
  data: {
    description: "Success" | string;
    data: QuoteData;
  };
};

export default function useRequestMedical() {
  const [data, setResponseData] = useState<QuoteData>();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<null | AxiosError>(null);
  const { referenceId } = useSelector((state: RootState) => state.quote);
  const dispatch = useDispatch();

  const patchMedicalResponse = async ({
    travellerId,
    hashCode,
    version,
    viewPage,
    medicalVersion,
    isAlter = null,
  }: AddMedicalProps) => {
    // Request payload
    const requestBody = {
      data: {
        type: QUOTE_JOURNEY_TYPE,
        channel: QUOTE_CHANNEL_ONLINE,
        version,
        viewPage,
        attributes: {
          domain: PRODUCT_DOMAIN,
          thirdPartyResponse: {
            type: THIRDPARTYRESPONSE_TYPE,
            response: {
              medical: {
                travellerEncryptedId: travellerId,
                hashCode,
                isAlter,
                version: medicalVersion,
              },
            },
          },
        },
      },
    };

    try {
      setLoading(true);

      const url = `${process.env.NEXT_PUBLIC_BASE_URL}/quote/${referenceId}/handleMedicalResponse`;
      const response: QuoteResponse = await axioInstance.patch(
        url,
        requestBody
      );

      setResponseData(response.data?.data);
    } catch (err) {
      setError(err as AxiosError);
    } finally {
      dispatch(updateQuoteCompleted({ completed: true }));
      setLoading(false);
    }
  };

  return { patchMedicalResponse, data, loading, error };
}
